import { useEffect, useRef, useState, type UIEvent } from 'react';

export const TERMS_SCROLL_BOTTOM_THRESHOLD = 8;

interface UseTermsAcceptanceOptions {
  isActive?: boolean;
}

export function useTermsAcceptance({
  isActive = true,
}: UseTermsAcceptanceOptions = {}) {
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);
  const termsContentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!isActive) {
      return;
    }

    setHasScrolledToBottom(false);
    setHasAcceptedTerms(false);
    if (termsContentRef.current) {
      termsContentRef.current.scrollTop = 0;
    }
  }, [isActive]);

  const handleTermsScroll = (event: UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
    const distanceToBottom = scrollHeight - scrollTop - clientHeight;

    if (distanceToBottom <= TERMS_SCROLL_BOTTOM_THRESHOLD) {
      setHasScrolledToBottom(true);
    }
  };

  return {
    hasScrolledToBottom,
    hasAcceptedTerms,
    setHasAcceptedTerms,
    termsContentRef,
    handleTermsScroll,
  };
}
